import { connect } from 'react-redux';
import { getDRE } from '../publicSession/selectors';
const mapStateToProps = (state)=>({
        dre: getDRE(state)
    });
export default connect(mapStateToProps);

//# sourceMappingURL=dre.container.js.map